exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.panel-base-container{margin-bottom:20px!important;padding:0!important\n}\n.panel-title{background:#5a61f6;padding:5px 10px\n}\n.panel-title h2,.panel-title p,.panel-title span{color:#fff!important\n}\n.panel-title-divider{margin-top:1px\n}\n.panel-loader.v-progress-linear{margin:0\n}\n.panel-slot-actions .v-icon{cursor:pointer;font-size:20px!important;margin-left:8px;margin-right:8px\n}\n.panel-section{background:#fff;margin-top:10px!important;padding:15px 0!important\n}", ""]);

// exports
